import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
import { imageTitleAndDescription } from './twoColumnsLayout';

const portalForm: ThemeUICSSObject = {
  '&.extended .container': {
    maxWidth: 'unset',
  },
  '.container': {
    minWidth: '320px',
    maxWidth: 'root',
    width: '100%',
    p: spacing(7),
    pt: spacing(6),
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(6),
    mx: 'auto',

    '.formsTab': {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
    },

    '& > header': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: responsive({ 0: 0, 2: 5 }),
      flexDirection: responsive({ 0: 'column-reverse', 2: 'row' }),
      width: '100%',
      background: responsive({ 0: 'background', 4: 'transparent' }),
      zIndex: responsive({ 0: '10', 4: 'auto' }),

      'div.imageTitleAndDescription': imageTitleAndDescription,

      '.iconsBar': {
        display: 'flex',
        width: responsive({ 0: '100%', 2: 'max-content' }),
        justifyContent: 'end',
        flexShrink: 0,
        flexDirection: 'row',

        'button, a': {
          flexBasis: '30px',
          flexShrink: 0,
          bg: 'transparent',
          color: 'secondary',
          padding: 0,
          height: 'auto',
          textAlign: 'center',

          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',

          '&.toggleMenu': {
            display: responsive({ 0: 'flex', 4: 'none' }),
          },

          svg: {
            width: responsive({ 0: '22px', 5: '25px', 6: '27px' }),
            height: responsive({ 0: '22px', 5: '25px', 6: '27px' }),
            m: 'auto',
          },

          '&:hover': {
            color: 'primary',

            svg: {
              color: 'primary',
            },
          },
        },

        '.favorite': {
          svg: {
            color: 'favorite',
            path: { fill: 'favorite' },
          },
        },
      },
    },
  },

  display: 'flex',
  flexDirection: 'column',
  gap: spacing(7),

  '.buttonBar': {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: responsive({ 0: 'column', 2: 'row' }),
    gap: spacing(3),
  },
};

export default portalForm;
